import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=3ac66917&scoped=true&lang=pug&"
import script from "./Clientes.vue?vue&type=script&lang=js&"
export * from "./Clientes.vue?vue&type=script&lang=js&"
import style0 from "./Clientes.vue?vue&type=style&index=0&id=3ac66917&lang=stylus&scoped=true&"
import style1 from "./Clientes.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac66917",
  null
  
)

export default component.exports